import React from "react";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import ExternalTextEditor from "../../../../componentLibrary/ExternalTextEditor";

export default function VideoContentCard({
  component,
  handleContentChange,
}: {
  component: ComponentI;
  handleContentChange: (id: string, field: string, value: string) => void;
}) {
  return (
    <Card>
      <div className="space-y-2">
        <Input
          value={component.content.title}
          onChange={(e) =>
            handleContentChange(component._id, "title", e.target.value)
          }
          label="Title"
          placeholder="Managing Conflict"
        />
        <Input
          value={component.content.url}
          onChange={(e) =>
            handleContentChange(component._id, "url", e.target.value)
          }
          label="Link"
          placeholder="www.vimeo.com/..."
          required
        />
        <ExternalTextEditor
          value={component.content.transcript}
          handleChange={(value) =>
            handleContentChange(component._id, "transcript", value)
          }
          placeholder="Enter transcript here..."
          label="Transcript"
        />
      </div>
    </Card>
  );
}
